import { useState } from "react";
import { genres, topics } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function TopicsSection() {
  const [activeGenre, setActiveGenre] = useState<string>("热血");

  return (
    <section id="topics" className="border-b border-background-200/70">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          index="03"
          eyebrow="Special Features"
          title="专题与企划"
          desc="围绕一个题材或一条主线持续更新的深度内容，适合一次读个够。"
          actionLabel="全部专题"
          actionHref="#topics"
        />

        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {topics.map((topic) => (
            <article key={topic.title} className="group cursor-pointer">
              <figure className="relative overflow-hidden rounded-lg bg-background-100">
                <div className="relative h-[360px] w-full md:h-[400px]">
                  <img
                    src={topic.image}
                    alt={topic.alt}
                    title={`${topic.title} · 动漫专题`}
                    className="h-full w-full object-cover object-top transition-transform duration-700 group-hover:scale-[1.04]"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/20 to-transparent"></div>
                </div>
                <span className="absolute top-4 left-4 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-foreground-950">
                  {topic.no}
                </span>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="font-heading text-lg leading-snug font-bold text-background-50">
                    {topic.title}
                  </h3>
                  <p className="mt-2 text-sm leading-6 text-background-100/90">{topic.desc}</p>
                  <p className="mt-3 flex items-center gap-1.5 text-xs text-primary-200">
                    <i className="ri-stack-line text-sm"></i>
                    {topic.count}
                  </p>
                </div>
              </figure>
            </article>
          ))}
        </div>

        {/* genre browse */}
        <div className="mt-12 rounded-lg border border-background-200/70 bg-background-100/50 p-5 md:p-6">
          <div className="flex flex-wrap items-center justify-between gap-3">
            <div>
              <h3 className="font-heading text-base font-black text-foreground-950">
                按类型浏览动漫资讯
              </h3>
              <p className="mt-1 text-xs text-foreground-500">
                选择你感兴趣的类型，快速定位相关新番与评测
              </p>
            </div>
            <span className="text-xs text-foreground-500">共 {genres.length} 个分类</span>
          </div>
          <div className="mt-4 flex flex-wrap gap-2">
            {genres.map((genre) => (
              <button
                key={genre}
                type="button"
                onClick={() => setActiveGenre(genre)}
                className={
                  activeGenre === genre
                    ? "cursor-pointer rounded-full bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors"
                    : "cursor-pointer rounded-full border border-background-300 bg-background-50 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:border-foreground-400 hover:text-foreground-950"
                }
              >
                {genre}
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}